// extracted by mini-css-extract-plugin
module.exports = {"category":"category-module--category--2oB-s","show":"category-module--show--DEVLV"};